<template>
  <div class="user-manager">
    <h1>Manajemen Pengguna</h1>
    <p class="subtitle">Tambah, lihat, dan kelola akun psikolog dan admin lain di sistem.</p>
    
    <div class="manager-grid">
      <!-- Kolom Daftar Pengguna -->
      <div class="card">
        <h2>Daftar Pengguna</h2>
        <div v-if="isLoading" class="loading-placeholder">Memuat...</div>
        <div v-else class="table-container">
          <table>
            <thead>
              <tr>
                <th>Nama Lengkap</th>
                <th>Email</th>
                <th>Peran</th>
                <!-- <th>Aksi</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.full_name || '-' }}</td>
                <td>{{ user.email }}</td>
                <td><span class="badge" :class="user.role">{{ user.role }}</span></td>
                <!-- <td class="actions">
                  <button class="action-btn edit-btn">Edit</button>
                  <button class="action-btn delete-btn">Hapus</button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Kolom Tambah Pengguna Baru -->
      <div class="card">
        <h2>Tambah Pengguna Baru</h2>
        <form @submit.prevent="addUser" class="add-form">
          <div class="form-group">
            <label for="full-name">Nama Lengkap</label>
            <input id="full-name" v-model="newUser.full_name" placeholder="Nama untuk TTD" />
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input id="email" v-model="newUser.email" type="email" placeholder="email@example.com" required />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input id="password" v-model="newUser.password" type="password" placeholder="Password Awal" required />
          </div>
          <div class="form-group">
            <label for="role">Peran</label>
            <select id="role" v-model="newUser.role">
              <option value="admin">Admin / Psikolog</option>
              <option value="superadmin">Superadmin</option>
            </select>
          </div>

          <div class="form-group">
            <label for="admin-gerai">Gerai (Opsional)</label>
            <select id="admin-gerai" v-model="newUser.gerai_id">
              <option :value="null">-- Tidak Terikat Gerai (Psikolog) --</option>
              <option v-for="gerai in allGerai" :key="gerai.id" :value="gerai.id">
                {{ gerai.name }}
              </option>
            </select>
            <small>Hanya isi jika role-nya adalah 'admin'.</small>
          </div>
          <!-- Tampilkan dropdown ini jika perannya bukan superadmin -->
        <div v-if="newUser.role !== 'superadmin'" class="form-group">
        <label>Atasan (Opsional)</label>
        <select v-model="newUser.parent_id">
            <option :value="null">-- Tidak Ada (Psikolog Utama) --</option>
            <option v-for="psy in mainPsychologists" :key="psy.id" :value="psy.id">
            {{ psy.full_name || psy.email }}
            </option>
        </select>
        </div>
          <button type="submit" :disabled="isSaving" class="submit-btn">
            {{ isSaving ? 'Menyimpan...' : 'Simpan Pengguna' }}
          </button>
        </form>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import apiClient from '@/services/api.js';

const users = ref([]);
const isLoading = ref(true);
const isSaving = ref(false);
const error = ref('');

const allGerai = ref([]);

// Fungsi untuk mengambil daftar gerai
const fetchAllGerai = async () => {
  try {
    const response = await apiClient.get('/admin/gerai/');
    allGerai.value = response.data;
  } catch (err) {
    console.error("Gagal memuat daftar gerai.", err);
  }
};

const mainPsychologists = computed(() => {
  return users.value.filter(u => (u.role === 'admin' || u.role === 'superadmin') && !u.parent_id);
});

// --- PERBAIKI OBJEK newUser DI SINI ---
const newUser = ref({
  email: '',
  password: '',
  role: 'admin',
  full_name: '',
  parent_id: null,
  gerai_id: null, // Tambahkan gerai_id dengan nilai awal null
});

const fetchUsers = async () => {
  isLoading.value = true;
  try {
    const response = await apiClient.get('/admin/users/');
    users.value = response.data;
  } catch (err) { 
    error.value = "Gagal memuat pengguna. Anda mungkin bukan Superadmin."; 
  } finally { 
    isLoading.value = false; 
  }
};

const addUser = async () => {
  isSaving.value = true;
  error.value = '';
  try {
    // Pastikan gerai_id di-reset ke null jika role bukan 'admin'
    if (newUser.value.role !== 'admin') {
        newUser.value.gerai_id = null;
    }
    
    await apiClient.post('/admin/users/', newUser.value);
    
    // Reset form setelah berhasil
    newUser.value = { email: '', password: '', role: 'admin', full_name: '', parent_id: null, gerai_id: null };
    
    await fetchUsers(); // Muat ulang daftar pengguna
    alert("Pengguna baru berhasil ditambahkan.");
  } catch (err) {
    error.value = err.response?.data?.detail || "Gagal menambahkan pengguna.";
  } finally {
    isSaving.value = false;
  }
};

onMounted(() => {
  fetchUsers();
  fetchAllGerai(); // Panggil fungsi ini untuk mengisi dropdown gerai
});
</script>

<style scoped>
.user-manager {
  max-width: 1200px;
  margin: auto;
  padding: 30px;
}
h1 { margin: 0; }
.subtitle { margin: 5px 0 20px 0; color: #555; }
.card {
  margin-top: 20px;
  padding: 25px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);
  border: 1px solid #eee;
}

.manager-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 25px;
  align-items: flex-start;
}

@media (max-width: 992px) {
  .manager-grid {
    grid-template-columns: 1fr;
  }
}

/* --- Form --- */
.add-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.form-group {
  display: flex;
  flex-direction: column;
}
.form-group label {
  margin-bottom: 6px;
  font-weight: 500;
  font-size: 0.9em;
  color: #333;
}
.form-group input, .form-group select {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1em;
}
.submit-btn {
  margin-top: 10px;
  padding: 12px;
  background-color: #1abc9c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
}
.submit-btn:disabled { background-color: #95a5a6; cursor: not-allowed; }

/* --- Tabel --- */
.loading-placeholder { text-align: center; padding: 40px; color: #777; }
.table-container { overflow-x: auto; }
table { width: 100%; border-collapse: collapse; }
th, td { text-align: left; padding: 14px 16px; border-bottom: 1px solid #f0f0f0; }
th { background-color: #f8f9fa; font-weight: 600; color: #555; font-size: 0.9em; }
tr:last-child td { border-bottom: none; }
.badge {
  padding: 5px 10px;
  border-radius: 12px;
  font-size: 0.8em;
  font-weight: bold;
  color: white;
  text-transform: capitalize;
}
.badge.superadmin { background-color: #e74c3c; }
.badge.admin { background-color: #3498db; }

.error { color: red; margin-top: 15px; }
</style>